<template>
  <ll-tooltip
    v-if="props.preview && props.href && !props.disabled"
    placement="top"
    :max-width="600"
    :overlay-style="{ maxWidth: 'none' }"
    is-white-bg
    :container-style="{ display: 'inline-block' }"
  >
    <template #title>
      <div
        style="
          width: 240px;
          height: 135px;
          overflow: hidden;
          background: #f0f2f5;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        "
      >
        <a-spin :spinning="!isImgLoaded">
          <img
            :src="`https://s0.wp.com/mshots/v1/${encodeURIComponent(
              props.href,
            )}?w=480&h=270`"
            style="width: 100%; height: 100%; object-fit: cover"
            alt="Link Preview"
            @load="handleImgLoad"
          />
        </a-spin>
      </div>
    </template>
    <a
      :class="[
        bem.b(),
        props.disabled ? bem.is('disabled') : '',
        props.colorType ? bem.is(props.colorType) : '',
        props.typeChange ? bem.is('type-change') : '',
        props.underlineStatus === 'fixed'
          ? bem.is('fixed-underline')
          : props.underlineStatus === 'hover'
            ? bem.is('underline')
            : '',
        ,
      ]"
      :style="{ gap: addUnit(props.gap), ...computedLinkColor }"
      :href="computedHref"
      :target="props.target"
      @click="handleClick"
    >
      <ll-icon
        v-if="props.prefixIcon"
        :icon-name="`icon-${props.prefixIcon}`"
        :size="props.iconSize"
        :class="bem.e('prefix-icon')"
      />
      <span :class="bem.e('text')">
        <slot>{{ props.value }} </slot>
      </span>
      <ll-icon
        v-if="props.suffixIcon"
        :icon-name="`icon-${props.suffixIcon}`"
        :size="props.iconSize"
        :class="bem.e('suffix-icon')"
      />
    </a>
  </ll-tooltip>
  <a
    v-else
    :class="[
      bem.b(),
      props.disabled ? bem.is('disabled') : '',
      props.typeChange ? bem.is('type-change') : '',
      props.underlineStatus === 'fixed'
        ? bem.is('fixed-underline')
        : props.underlineStatus === 'hover'
          ? bem.is('underline')
          : '',
    ]"
    :style="{ gap: addUnit(props.gap), ...computedLinkColor }"
    :href="computedHref"
    :target="props.target"
    @click="handleClick"
  >
    <ll-icon
      v-if="props.prefixIcon"
      :icon-name="`icon-${props.prefixIcon}`"
      :size="props.iconSize"
      :class="bem.e('prefix-icon')"
    />
    <span :class="bem.e('text')">
      <slot>{{ props.value }} </slot>
    </span>
    <ll-icon
      v-if="props.suffixIcon"
      :icon-name="`icon-${props.suffixIcon}`"
      :size="props.iconSize"
      :class="bem.e('suffix-icon')"
    />
  </a>
</template>

<script setup lang="ts">
import { addUnit, createNamespace } from '@ll-plus/utils'
import { computed, ref } from 'vue'
import { linkColorMap, linkProps } from './link'

defineOptions({
  name: 'LlLink',
})

const bem = createNamespace('link')

// 定义组件属性
const props = defineProps(linkProps)

// 定义组件事件
const emits = defineEmits(['click'])

const isImgLoaded = ref(false)

// 计算链接地址
const computedHref = computed(() => {
  if (props.disabled) return 'javascript:;'
  return props.href || 'javascript:;'
})

const computedLinkColor = computed(() => {
  return props.typeChange
    ? {
        '--a-color':
          linkColorMap[props.colorType]?.['link'] ||
          props.linkColor ||
          '#005ce5',
        '--a-link-color':
          linkColorMap[props.colorType]?.['link'] || props.linkColor,
        '--a-hover-color':
          linkColorMap[props.colorType]?.['hover'] || props.hoverColor,
        '--a-active-color':
          linkColorMap[props.colorType]?.['active'] || props.activeColor,
      }
    : {
        '--a-color':
          linkColorMap[props.colorType]?.['link'] ||
          props.linkColor ||
          '#005ce5',
      }
})

// 点击处理
const handleClick = (event) => {
  if (props.disabled || !props.href) {
    event.preventDefault()
    return
  }

  emits('click', event)
}

const handleImgLoad = () => {
  isImgLoaded.value = true
}
</script>
